import PropTypes from 'prop-types'
import ButtonToggle from '../ui/ButtonToggle'

const IndicarProductoEstado = ({ checked, onChange }) => {
  return (
    <ButtonToggle
      checked={checked}
      name="esNuevo"
      textOn="Nuevo"
      textOff="Usado"
      onChange={onChange}
    />
  )
}

IndicarProductoEstado.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

export default IndicarProductoEstado
